export default __webpack_public_path__ + "static/media/mask4.b78fc9a4.png";